
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[mobileOrDesktop]/[hostname]/order",
      function () {
        return require("private-next-pages/_sites/[mobileOrDesktop]/[hostname]/order/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[mobileOrDesktop]/[hostname]/order"])
      });
    }
  